import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';
import { CaseQtyCell } from './case-qty-cell';

export const CaseQty: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Case Qty',
  minWidth: 40,
  accessorFn: (product) => `${product.case_qty}`,
  cell: ({ row }) => <CaseQtyCell product={row.original} />,
  gloss: 'How many units come in one case from the vendor — say, 12 bottles in a case of wine.',
});
